import { ReactNode } from 'react';

import { DatetimeShow } from '@fhs/ui';

import {
  capreseCAEndDate,
  capreseCAStartDate,
  hotOnesEndDate,
  hotOnesStartDate,
} from '../constants';

export type LtoContentCAProps = {
  default?: ReactNode;
  hotOnes: ReactNode;
  ltoContent: ReactNode;
};

export const LtoContentCA = ({
  ltoContent,
  default: defaultContent,
  hotOnes,
}: LtoContentCAProps) => {
  return (
    <DatetimeShow
      after={capreseCAStartDate}
      before={capreseCAEndDate}
      default={
        <DatetimeShow after={hotOnesStartDate} before={hotOnesEndDate} default={defaultContent}>
          {hotOnes}
        </DatetimeShow>
      }
    >
      {ltoContent}
    </DatetimeShow>
  );
};
